import SchoolService from '@/services/school.service';
import axios from "axios";

export const schoolModule = {
    namespaced: true,
    state: {
        requests: [],
        schools: new Map()
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async listSchools({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listSchools");
            return SchoolService.listSchools(axiosSource).then(
                async data => {
                    commit('updateSchoolList', data);
                    await dispatch('clearRequest', "listSchools");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createSchool({commit, dispatch}, school) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createSchool");
            return SchoolService.createSchool(axiosSource, school).then(
                async data => {
                    commit('insertSchool', data);
                    await dispatch('clearRequest', "createSchool");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateSchool({commit, dispatch}, {schoolId, school}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateSchool");
            return SchoolService.updateSchool(axiosSource, schoolId, school).then(
                async data => {
                    commit('updateSchoolData', data);
                    await dispatch('clearRequest', "updateSchool");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteSchool({commit, dispatch}, schoolId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteSchool");
            return SchoolService.deleteSchool(axiosSource, schoolId).then(
                async data => {
                    commit('removeSchoolFromList', schoolId);
                    await dispatch('clearRequest', "deleteSchool");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateSchoolList(state, data) {
            state.schools = new Map()
            for (const entity of data) {
                state.schools.set(entity.id, entity)
            }
        },
        insertSchool(state, data) {
            state.schools.set(data.id, data)
        },
        updateSchoolData(state, data) {
            state.schools.set(data.id, data)
        },
        removeSchoolFromList(state, schoolId) {
            state.schools.delete(schoolId)
        },
    }
};